import { Skeleton, Text, RemoveShoppingCartIcon } from '@mercai/clever'
import { useTranslation } from 'react-i18next'

import type { CardOrderCancellationReasonProps } from './card-order-cancellation-reason.type'

import styles from './card-order-cancellation-reason.module.css'

const CardOrderCancellationReasonDefault = ({
  cancellationReason,
}: CardOrderCancellationReasonProps) => {
  const { t } = useTranslation('componentCardsOrderCenterShow')

  return (
    <div className={styles.core}>
      <div className={styles.title}>
        <RemoveShoppingCartIcon />
        <Text variant="title-base">{t('orderCancellationReasonTitle')}</Text>
      </div>

      <div className={styles.content}>
        <Text variant="title-base" className={styles.reason}>
          <strong>{t('orderCancellationReasonReasonTitle')}</strong>
          {cancellationReason?.reason || '-'}
        </Text>
        <Text variant="title-base" className={styles.observation}>
          <strong>{t('orderCancellationReasonObservationTitle')}</strong>
          {cancellationReason?.observation || '-'}
        </Text>
      </div>
    </div>
  )
}

const CardOrderCancellationReasonLoading = () => {
  const { t } = useTranslation('componentCardsOrderCenterShow')
  return (
    <div className={styles.core}>
      <div className={styles.title}>
        <RemoveShoppingCartIcon />
        <Text variant="title-base">{t('orderCancellationReasonTitle')}</Text>
      </div>

      <div className={styles.content}>
        <Text variant="title-base" className={styles.reason}>
          <strong>{t('orderCancellationReasonReasonTitle')}</strong>
          <Skeleton width="60%" height="1rem" />
        </Text>
        <Text variant="title-base" className={styles.observation}>
          <strong>{t('orderCancellationReasonObservationTitle')}</strong>
          <Skeleton width="60%" height="1rem" />
        </Text>
      </div>
    </div>
  )
}

export const CardOrderCancellationReason = (
  props: CardOrderCancellationReasonProps,
) => {
  if (props.isLoading) {
    return <CardOrderCancellationReasonLoading />
  }

  return <CardOrderCancellationReasonDefault {...props} />
}
